import React from 'react'
import { Button, Stack, Box, SimplePopover, SubMenu } from '@/components/lib'

export default function ConfirmButton ({ header, body, footer, trigger, onConfirm, action, actionColor, closeOnBlur, asSubMenu }) {
  if (asSubMenu) {
    return (
      <SubMenu trigger={trigger}>
        <Stack p={3}>
          {header && <Box fontWeight='bold'>{header}</Box>}
          {body && <Box>{body}</Box>}
          <Stack direction='row' justifyContent='end'>
            <Button
              onClick={() => {
                if (onConfirm) onConfirm()
                if (action) action()
              }} colorPalette={actionColor || 'gray'}
            >Confirm
            </Button>
          </Stack>
          {footer && <Box textAlign='right'>{footer}</Box>}
        </Stack>
      </SubMenu>
    )
  }
  return (
    <SimplePopover
      closeOnBlur={closeOnBlur ?? true}
      trigger={trigger}
      header={header}
      body={
        <Stack>
          {body && <Box>{body}</Box>}
          <Stack direction='row' justifyContent='end'>
            <Button
              onClick={() => {
                if (onConfirm) onConfirm()
                if (action) action()
              }} colorPalette={actionColor || 'gray'}
            >Confirm
            </Button>
          </Stack>
        </Stack>
}
      footer={<Box textAlign='right'>{footer}</Box>}
    />
  )
}
